const location = window.location;

/**
 * @param {String} relativePath
 * @returns {String}
 */
export const makeAbsoluteUrl = relativePath => (
  `${location.protocol}//${location.host}/${relativePath}`
)
